import { useState } from "react";
import dynamic from "next/dynamic";

/*** Vendors ***/

/*** components ***/
import Button from "components/atoms/Button";
const ModalDialog = dynamic(() => import("components/atoms/ModalDialog"), {
  ssr: false,
});
const ModalBody = dynamic(
  () =>
    import("components/atoms/ModalDialog").then((module) => {
      return module.ModalBody;
    }),
  {
    ssr: false,
  }
);
const ContactForm = dynamic(() => import("components/organisms/ContactForm"), {
  ssr: false,
});

/*** ========== ***/

/**
 *
 * @param {{
 * }} props Props for the component
 *
 */
const ContactButton = (props) => {
  const { wrapper, children, requestService, ...otherProps } = props;
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <div className={wrapper?.className}>
      <Button onClick={() => setIsOpenModal(true)} {...otherProps}>
        {children}
      </Button>
      <ModalDialog
        size="lg"
        isOpen={isOpenModal}
        cancelCallBack={() => setIsOpenModal(false)}
      >
        <ModalBody>
          <ContactForm
            className="py-10 px-4 lg:py-15 lg:px-10"
            subject={requestService}
            isLazyLoad={false}
            callback={(res) => setIsOpenModal(false)}
          />
        </ModalBody>
      </ModalDialog>
    </div>
  );
};

export default ContactButton;
